export const EVENT_LAYOUTS = {
    DEFAULT: 'default',
    SCHEDULE: 'schedule',
};

export const SESSION_KINDS = [
    { value: 'talk', label: 'Palestra' },
    { value: 'workshop', label: 'Minicurso' },
    { value: 'panel', label: 'Mesa-redonda' },
    { value: 'ceremony', label: 'Cerimônia' },
    { value: 'other', label: 'Atividade' },
];

const WEEKDAYS = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'];

export function kindLabel(kind) {
    return SESSION_KINDS.find(item => item.value === kind)?.label || 'Atividade';
}

/** A página só troca de layout quando o produtor escolheu e já há o que mostrar. */
export function hasScheduleLayout(event) {
    return event?.layout === EVENT_LAYOUTS.SCHEDULE && !!event?.sessions?.length;
}

/** "2026-11-09" -> { weekday: 'Seg', label: '09/11' } */
export function formatDay(day) {
    const [year, month, date] = String(day).split('-');
    const weekday = WEEKDAYS[new Date(`${day}T12:00:00`).getDay()];

    return { weekday, label: `${date}/${month}`, year };
}

export function groupSessionsByDay(sessions = []) {
    const days = {};

    sessions.forEach(session => {
        (days[session.date] = days[session.date] || []).push(session);
    });

    return Object.keys(days)
        .sort()
        .map(date => ({
            date,
            items: days[date].sort((a, b) => `${a.start}`.localeCompare(`${b.start}`) || a.sort_order - b.sort_order),
        }));
}

export function ticketProducts(event) {
    return (event?.products || []).filter(product => product.type === 'ticket');
}

/** Tem lote à venda? Evita oferecer, numa sessão, um ingresso que já esgotou. */
export function isTicketAvailable(product) {
    return (product?.batches || []).some(batch => batch.quantity_available > 0 && !batch.upcoming);
}

/** O carrinho guarda lotes; a sessão aponta para ingressos (produtos). */
export function selectedProductIds(event, selectedBatches = []) {
    const batchToProduct = {};

    (event?.products || []).forEach(product => {
        (product.batches || []).forEach(batch => {
            batchToProduct[batch.id] = product.id;
        });
    });

    return new Set(
        selectedBatches
            .filter(item => item.quantity > 0)
            .map(item => batchToProduct[item.id])
            .filter(Boolean)
    );
}

/** Ids das sessões que o carrinho atual libera. */
export function coveredSessionIds(event, selectedBatches = []) {
    const products = selectedProductIds(event, selectedBatches);
    const covered = new Set();

    if (!products.size) {
        return covered;
    }

    (event?.sessions || []).forEach(session => {
        if (session.open_access || session.product_ids?.some(id => products.has(id))) {
            covered.add(session.id);
        }
    });

    return covered;
}
